var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"help"}},[_c('div',{attrs:{"id":"help-content-main"}},[_c('iframe',{attrs:{"width":"100%","frameborder":"no","border":"0","height":"100%","src":_vm.helpSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }